/** Enum describing where to place Merkmale in table
 * DO:     import { MerkmalPlacement } from './PivotTableFilterBox'
 * DO NOT: import MerkmalPlacement from './PivotTableFilterBox'  (you will get a pointer to FilterBox instead)
*/
export const MerkmalPlacement = Object.freeze({
  NWBlock: 'nwblock', // eslint-disable-line: box in north-west corner of the table
  Header: 'header', // eslint-disable-line: vorspalte or kopfzeile
  None: 'none', // eslint-disable-line: nowhere; do not show
});

/*
Utilities for labels, values, and ids of the statistics (Zugriff auf die Hochschulstatistiken)
when an administator edits the user rights or create a user
 */

export const StatisticsAccessArray = [
  { label: 'Studierende', value: '21311_Studenten', id: 6 },
  { label: 'Prüfungen', value: '21321_Prüfungen', id: 7 },
  { label: 'Promovierende', value: '21352_Promovierende', id: 10 },
  { label: 'Habilitationen', value: '21351_Habilitationen', id: 9 },
  { label: 'Hochschulpersonal', value: '21341_Hochschulperso', id: 8 },
  { label: 'Hochschulfinanzen', value: '21371_Finanzen', id: 11 },
];

export const RoleAccessHelper = {
  INTERNAL_USER: 'FachNutzer',
  GROUP_ADMIN: 'FachAdministrator',
};

export const StatisticsAccessHelper = {
  '21311_Studenten': 6,
  '21321_Prüfungen': 7,
  '21341_Hochschulperso': 8,
  '21351_Habilitationen': 9,
  '21352_Promovierende': 10,
  '21371_Finanzen': 11,
};

export const StatisticsNames = {
  21311: 'Statistik der Studierenden',
  21321: 'Statistik der Prüfungen',
  21341: 'Statistik des Hochschulpersonals',
  21351: 'Statistik der Habilitationen',
  21352: 'Statistik der Promovierenden',
  21371: 'Hochschulfinanzstatistik',
};

export const StatisticsNamesShort = {
  21311: 'Studierende',
  21321: 'Prüfungen',
  21341: 'Hochschulpersonal',
  21351: 'Habilitationen',
  21352: 'Promovierende',
  21371: 'Hochschulfinanzstatistik',
};

export const StatisticsNamesNavigator = {
  21311: 'Studierende',
  21321: 'Prüfungen',
  21341: 'Hochschulpersonal',
  21351: 'Habilitationen',
  21352: 'Promovierende',
  21371: 'Hochschulfinanzen',
};

export const VariableTypeEnum = {
  TIME_IDENTIFYING: 'zeitidentifizierend',
  TIME_IDENTIFYING_TOTAL: 'zeitid. insgesamt',
  TIME_CLASSIFYING: 'zeitlich',
  TIME_CLASSIFYING_TOTAL: 'zeitlich insgesamt',
  SUBJECT_CLASSIFYING: 'sachlich',
  SUBJECT_CLASSIFYING_TOTAL: 'sachlich insgesamt',
  REGION_CLASSIFYING: 'räumlich',
  REGION_CLASSIFYING_TOTAL: 'räumlich insgesamt',
  VALUE: 'Wert',
  UNDEF: '',
  RULE: 'Regel',
  CLASSIFYING: 'klassifizierend',
  SUM: 'Insgesamt',
};

export const TableSavedNames = {
  personal: ['Persönlicher Ordner', 'folder_special', 'BEN'],
  shared: ['Gruppenordner', 'folder_shared', 'GRP'],
  transfer: ['Amtsinterner Ordner', 'folder', 'OFFICE'],
  free: ['Öffentlicher Ordner', 'folder', 'FREE'],
  admin: ['Freigabe von Nutzer-Objekten', 'assignment_turned_in', 'ALL'],
};

export const KeyFigureKey = {
  213811: 0,
  213812: 1,
};

export const KeyFigureNames = {
  nonmonetary: 'Nicht-monetäre Kennzahlen',
  monetary: 'Monetäre Kennzahlen',
};

export const KeyFigureNumbers = {
  // nonmonetary: '21311', // testing only
  nonmonetary: '213811',
  monetary: '213812',
};

export const KeyFigureStatistics = {
  // nonmonetary: '21311', // testing only
  213811: 'Nicht-monetäre Kennzahlen',
  213812: 'Monetäre Kennzahlen',
};

export const KeyStatusNames = {
  UNDEF: 'unbekannt',
  ACTUALISING: 'wird aktualisiert',
  BEING_REORGANISED: 'in Reoganisation',
  INCOMPLETE: 'unvollständig',
  COMPLETE_AND_EMPTY: 'vollständig und leer',
  COMPLETE_WITH_VALUES: 'vollständig mit Werten',
};

export const TypeNumbers = {
  variable: 0,
  structure: 1,
  folder: 1,
  rule: 2,
};

export const TypeNames = {
  variable: ['Wertmerkmale'],
  structure: ['Tabellen'],
  rule: ['Regeln'],
  ordercriterion: ['Ordnern'],
  folder: ['Ordner']
};

export const RightNames = {
  GRP: ['Gruppen'],
  BEN: ['Benutzer'],
};

export const getEntryNum = Object.freeze({
  BW: 'LAND08',
  BY: 'LAND09',
  BE: 'LAND11',
  BB: 'LAND12',
  HB: 'LAND04',
  HH: 'LAND02',
  HE: 'LAND06',
  MV: 'LAND13',
  NI: 'LAND03',
  NW: 'LAND05',
  RP: 'LAND07',
  SL: 'LAND10',
  SN: 'LAND14',
  ST: 'LAND15',
  SH: 'LAND01',
  TH: 'LAND16',
});

export const LandNames = {
  BW: 'Baden-Württemberg',
  BY: 'Bayern',
  BE: 'Berlin',
  BB: 'Brandenburg',
  HB: 'Bremen',
  HH: 'Hamburg',
  HE: 'Hessen',
  MV: 'Mecklenburg-Vorpommern',
  NI: 'Niedersachsen',
  NW: 'Nordrhein-Westfalen',
  RP: 'Rheinland-Pfalz',
  SL: 'Saarland',
  SN: 'Sachsen',
  ST: 'Sachsen-Anhalt',
  SH: 'Schleswig-Holstein',
  TH: 'Thüringen',
};

export const getEntryAbbreviation = Object.freeze({
  LAND08: 'BW',
  LAND09: 'BY',
  LAND11: 'BE',
  LAND12: 'BB',
  LAND04: 'HB',
  LAND02: 'HH',
  LAND06: 'HE',
  LAND13: 'MV',
  LAND03: 'NI',
  LAND05: 'NW',
  LAND07: 'RP',
  LAND10: 'SL',
  LAND14: 'SN',
  LAND15: 'ST',
  LAND01: 'SH',
  LAND16: 'TH',
});

// deep copy function
export default class JsonHelper {
  static deepCopy(jsonObject) {
    // erstelle eine DeepCopy, um ein unabhängiges JSON-Objekt erhalten
    return JSON.parse(JSON.stringify(jsonObject));
    // return JSON.parse(JSON.stringify(jsonObject).toString('utf8'));
  }

  static objectContains(obj, str) {
    // return Boolean ob Object obj enthalt den String str
    return Boolean(JSON.stringify(obj).indexOf(str) !== -1);
  }
}

// TableStandard Heading
export const HeadingNames = {
  21311: '',
  21321: 'Prüfungsjahr',
  21341: 'Berichtsjahr',
  21351: 'Berichtsjahr',
  21352: 'Berichtsjahr',
  21371: 'Berichtsjahr',
};

// Statistic Number to item in JSON for Standard Folders
export const StatisticNumbers = {
  21311: 0,
  21321: 1,
  21341: 2,
  21351: 3,
  21352: 4,
  21371: 5,
};

export const StatisticNumbersFolders = {
  21311: 0,
  21321: 1,
  21341: 2,
  21351: 3,
  21352: 4,
  21371: 5,
};

export const CategoryEnums = {
  SUMMARY: 0,
  DETAILED: 1,
  UNDEF: 2,
};

export const StatisticCount = {
  0: 21311,
  1: 21321,
  2: 21341,
  3: 21351,
  4: 21352,
  5: 21371,
};

export const CategoryCount = {
  0: 'SUMMARY',
  1: 'DETAILED',
  2: 'UNDEF',
};

export const saveVariables = [ // kopiere nur diese state-Variablen
  // 'tableRendered',
  'prefixById',
  'sumUp',
  'sepQual',
  'calcModeOn',
  'calcModeOnById',
  'previewDeactivatedRadio',
  'previewDeactivated',
  'visible',
  'value',
  'valueEmptyLines', //
  'filter',
  'filter_graph',
  'colArray',
  'colGraphArray',
  'rowArray',
  'rowGraphArray',
  'precondition_graph',
  'pureFilter_graph',
  'merkmal1',
  'headings',
  'headings_graph',
  'zeilen',
  'zeilen_graph',
  'spalte1',
  'spalte1_graph',
  //'rulesMap',
  //'auspraegungenMap',
  'arrFiltersById',
  'arrSelectedTreeNodes',
  'hierarchySelection',
  'outputEntry',
  'arrRuleCharById',
  'arrRuleById',
  //'arrRulesById',
  'arrSortingById',
  'arrDisplayById',
  'arrBMMById',
  'arrDirectionById',
  'arrSumUpById',
  'arrCalcUpById',
  'overlayFilter',
  'overlayHasFilter',
  'overlayId',
  'showAverage',
  'showMedian',
  'arrNameById',
  'spalte2',
  'spalte2_graph',
  'spalte3',
  'spalte3_graph',
  'spalte4',
  'spalte4_graph',
  'spalte5',
  'spalte5_graph',
  'spalte6',
  'spalte6_graph',
  'spalte7',
  'spalte7_graph',
  'spalte8',
  'spalte8_graph',
  'spalte9',
  'spalte9_graph',
  'spalte10',
  'spalte10_graph',
  'spalte11',
  'spalte11_graph',
  'spalte12',
  'spalte12_graph',
  'spalte13',
  'spalte13_graph',
  'spalte14',
  'spalte14_graph',
  'spalte15',
  'spalte15_graph',
  'spalte16',
  'spalte16_graph',
  'spalte17',
  'spalte17_graph',
  'spalte18',
  'spalte18_graph',
  'spalte19',
  'spalte19_graph',
  'spalte20',
  'spalte20_graph',
  'spalte21',
  'spalte21_graph',
  'spalte22',
  'spalte22_graph',
  'spalte23',
  'spalte23_graph',
  'spalte24',
  'spalte24_graph',
  'spalte25',
  'spalte25_graph',
  'spalte26',
  'spalte26_graph',
  'spalte27',
  'spalte27_graph',
  'spalte28',
  'spalte28_graph',
  'spalte29',
  'spalte29_graph',
  'spalte30',
  'spalte30_graph',
  'spalte31',
  'spalte31_graph',
  'spalte32',
  'spalte32_graph',
  'spalte33',
  'spalte33_graph',
  'spalte34',
  'spalte34_graph',
  'spalte35',
  'spalte35_graph',
  'spalte36',
  'spalte36_graph',
  'spalte37',
  'spalte37_graph',
  'spalte38',
  'spalte38_graph',
  'spalte39',
  'spalte39_graph',
  'spalte40',
  'spalte40_graph',
  'zeile1',
  'zeile2',
  'zeile2_graph',
  'zeile3',
  'zeile3_graph',
  'zeile4',
  'zeile4_graph',
  'selectedStatistics',
  'selectedRegional',
  'noTable',
];

export const changeVariables = [
  'filter',
  'filter_graph',
  'colArray',
  'colGraphArray',
  'rowArray',
  'rowGraphArray',
  'precondition_graph',
  'pureFilter_graph',
  'merkmal1',
  'headings',
  'headings_graph',
  'zeilen',
  'zeilen_graph',
  'spalte1',
  'spalte1_graph',
  'spalte2',
  'spalte2_graph',
  'spalte3',
  'spalte3_graph',
  'spalte4',
  'spalte4_graph',
  'spalte5',
  'spalte5_graph',
  'spalte6',
  'spalte6_graph',
  'spalte7',
  'spalte7_graph',
  'spalte8',
  'spalte8_graph',
  'spalte9',
  'spalte9_graph',
  'spalte10',
  'spalte10_graph',
  'spalte11',
  'spalte11_graph',
  'spalte12',
  'spalte12_graph',
  'spalte13',
  'spalte13_graph',
  'spalte14',
  'spalte14_graph',
  'spalte15',
  'spalte15_graph',
  'spalte16',
  'spalte16_graph',
  'spalte17',
  'spalte17_graph',
  'spalte18',
  'spalte18_graph',
  'spalte19',
  'spalte19_graph',
  'spalte20',
  'spalte20_graph',
  'spalte21',
  'spalte21_graph',
  'spalte22',
  'spalte22_graph',
  'spalte23',
  'spalte23_graph',
  'spalte24',
  'spalte24_graph',
  'spalte25',
  'spalte25_graph',
  'spalte26',
  'spalte26_graph',
  'spalte27',
  'spalte27_graph',
  'spalte28',
  'spalte28_graph',
  'spalte29',
  'spalte29_graph',
  'spalte30',
  'spalte30_graph',
  'spalte31',
  'spalte31_graph',
  'spalte32',
  'spalte32_graph',
  'spalte33',
  'spalte33_graph',
  'spalte34',
  'spalte34_graph',
  'spalte35',
  'spalte35_graph',
  'spalte36',
  'spalte36_graph',
  'spalte37',
  'spalte37_graph',
  'spalte38',
  'spalte38_graph',
  'spalte39',
  'spalte39_graph',
  'spalte40',
  'spalte40_graph',
  'zeile1',
  'zeile2',
  'zeile2_graph',
  'zeile3',
  'zeile3_graph',
  'zeile4',
  'zeile4_graph',
];

export function maximizeTable(doMaximize) {
  // maximizeTable(doMaximize) {
  const implodeExpand = document.getElementById('implodeExpand');
  const pivotTableDiv = document.getElementById('pivotTableDiv');
  if (doMaximize) {
    implodeExpand.setAttribute(
      'style',
      'text-align: right; visibility: visible;',
    );
    pivotTableDiv.setAttribute(
      'style',
      'position: absolute; top: 0; left: 0; z-index: 1000; height: 100%; width: 100%; background-color: #F5F5F5;',
    );
  } else {
    implodeExpand.setAttribute(
      'style',
      'text-align: right; visibility: hidden;',
    );
    pivotTableDiv.setAttribute(
      'style',
      '',
    );
  }
}

export const KeyChildren = [
  {
    key: '0',
    data: {
      name: 'Nicht-monetäre Kennzahlen',
    },
    children: [
      {
        key: '0-0',
        data: {
          name: 'Quader',
        },
        children: [],
        selectable: false,
      },
      {
        key: '0-1',
        data: {
          name: 'Tabellen',
        },
        children: [],
        selectable: false,
      },
    ],
    selectable: false,
  },
  {
    key: '1',
    data: {
      name: 'Monetäre Kennzahlen',
    },
    children: [
      {
        key: '1-0',
        data: {
          name: 'Quader',
        },
        children: [],
        selectable: false,
      },
      {
        key: '1-1',
        data: {
          name: 'Tabellen',
        },
        children: [],
        selectable: false,
      },
    ],
    selectable: false,
  },
]; // children

export const KeyLinksArray = {
  213811: [
    {
      '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
      type: 'STATISTIC',
      name: '213811',
      reference: null,
      id: -1,
      shortDescription: '',
      idList: [],
    },
  ],
  213812: [
    {
      '@class': 'genesis.transfer.model.dto.directory.view.SimpleDirectoryLinkInfo',
      type: 'STATISTIC',
      name: '213812',
      reference: null,
      id: -1,
      shortDescription: '',
      idList: [],
    },
  ],
};
